import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Guard, Result, ValueObject } from '@digibricks/core';
export var BanInformation = /*#__PURE__*/function (_ValueObject) {
  _inherits(BanInformation, _ValueObject);

  var _super = _createSuper(BanInformation);

  function BanInformation() {
    _classCallCheck(this, BanInformation);

    return _super.apply(this, arguments);
  }

  _createClass(BanInformation, [{
    key: "bannedAt",
    get: function get() {
      return this.props.bannedAt;
    }
  }, {
    key: "message",
    get: function get() {
      return this.props.message;
    }
  }, {
    key: "reasonCode",
    get: function get() {
      return this.props.reasonCode;
    }
  }, {
    key: "securityViolation",
    get: function get() {
      return this.props.securityViolation;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var _props$message;

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread({}, props), {}, {
        message: (_props$message = props.message) !== null && _props$message !== void 0 ? _props$message : ''
      });

      return Result.ok(new BanInformation(defaultProps));
    }
  }, {
    key: "validate",
    value: function validate(props) {
      var guardCollection = [{
        argument: props.bannedAt,
        argumentName: 'Banned At'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return new BadInputError(guardResult.message);
      }

      return Result.ok();
    }
  }]);

  return BanInformation;
}(ValueObject);